import React from 'react';
import PipelineIntegrations from './PipelineIntegrations';
import PipelineIntegrationTableContextProvider from './PipelineIntegrationTableContextProvider';

export default function PipelineIntegrationsSection() {
  return (
    <PipelineIntegrationTableContextProvider>
      <PipelineIntegrations />
    </PipelineIntegrationTableContextProvider>
  );
}
